const validator = require('ui-validator');

const v = validator.validators;
const validations = {
  incomeAdditional: {
    dollarAmountRange: v.dollarAmountRange({
      min: 0,
      max: 9999999,
      underMinMessage: 'The income you have entered is negative',
      overMaxMessage: 'The income you have entered is above the maximum income allowed',
      invalidMessage: 'Enter a valid income',
    }),
  },
};

export default validations;

